export default (userPermissions: string[], permissions: string[]): boolean => {
  return userPermissions.some((p) => permissions.includes(p));
};
